module.exports = __webpack_public_path__ + "media/images/app-store-icon-a6a7ae0e4b59895ebccd38ff0388559b.png";